import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Avatar, Dialog, DialogContent, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { CloseRounded } from "@mui/icons-material";
import { AddSvg, CrossSvg, DeleteSvg, EditSvg, SwitchOffSvg, SwitchOnSvg } from "../../../assets/svg/index.js";
import MainDatatable from "../../../components/common/MainDatatable.jsx";
import logo_icon from '../../../assets/images/Logo/Bharat-Darshan-Logo.png';
import * as CategoryActions from '../../../redux/actions/categoryAction.js';
import * as SubCategoryActions from '../../../redux/actions/subCategoryAction.js';
import * as SancharActions from '../../../redux/actions/sancharAction';
import { api_urls } from "../../../utils/api-urls/index.js";

const DisplayPodcast = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { categoryData } = useSelector(state => state.categoryReducer);
  const { subCategoryData, subCatgeoryDataByCategoryId } = useSelector(state => state.subCategoryReducer);
  const { podcastData } = useSelector(state => state.sancharReducer);

  const redirectCategoryData = categoryData.filter(value => value?.redirect_page === 'Podcast');   //* Redirect Category Data For Category Name Option
  // const podcastData = [{ categoryName: 'Category One' }, { categoryName: 'Category Two' }];

  const [modalVisible, setModalVisible] = useState(false);
  const [podcastDetail, setPodcastDetail] = useState({ categoryId: '', subCategoryId: '', podcastId: '', podcastName: '', link: '', artist: '', duration: '', description: '', status: '' });
  const [inputFieldError, setInputFieldError] = useState({ categoryId: '', subCategoryId: '', podcastName: '', link: '', artist: '', duration: '', description: '', status: '', image: '' });
  const [image, setImage] = useState({ file: logo_icon, bytes: "" });
  const [audio, setAudio] = useState({ file: null, bytes: "" });
  const [trending, setTrending] = useState(false);

  //* Handle Input Field : Error
  const handleInputFieldError = (input, value) => {
    setInputFieldError((prev) => ({ ...prev, [input]: value }))
  }

  //* Handle Input Field : Data
  const handleInputField = (e) => {
    const { name, value } = e.target;
    setPodcastDetail({ ...podcastDetail, [name]: value });
  };

  //* Handle Image
  const handleImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setImage({
        file: URL.createObjectURL(e.target.files[0]),
        bytes: e.target.files[0],
      });
    }

    handleInputFieldError("image", null)
  };

  //* Handle Audio
  const handleAudio = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setAudio({
        file: URL.createObjectURL(e.target.files[0]),
        bytes: e.target.files[0],
      });
    }
    handleInputFieldError("audio", null);
  };

  //! Handle Edit - Podcast
  const handleEdit = (data) => {
    setModalVisible(!modalVisible)
    console.log("Edit Data ::: ", data)

    setPodcastDetail({
      podcastId: data?._id || '',
      categoryId: data?.audioCategoryId?._id || '',
      subCategoryId: data?.audioSubCategoryId?._id || '',
      podcastName: data?.title || '',
      link: data?.url || '',
      description: data?.description || '',
      artist: data?.artist || '',
      duration: data?.duration || '',
    });
    setTrending(data?.is_trending)
    setImage({ file: api_urls + data?.image || logo_icon })
    setAudio({ file: api_urls + data?.artwork })
  }

  //! Handle Submit - Updating Podcast
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Podcast Data :: ", { ...podcastDetail, trending, image: image?.bytes })
    const { podcastId, categoryId, subCategoryId, podcastName, link, description, artist, duration } = podcastDetail;

    let formData = new FormData()
    formData.append("audioId", podcastId)
    formData.append("audioCategoryId", categoryId)
    formData.append("audioSubCategoryId", subCategoryId)
    formData.append("title", podcastName)
    formData.append("url", link);
    formData.append("artist", artist);
    formData.append("duration", duration);
    formData.append("is_trending", trending);
    formData.append("status", 'Active');
    formData.append("description", description);
    formData.append("artwork", audio?.bytes);

    const payload = {
      data: formData,
      onComplete: () => setModalVisible(false)
    }

    //! Dispatching API for Updating Podcast
    dispatch(SancharActions.updatePodcast(payload))
  };

  //* DataTable Columns
  const podcastColumns = [
    { name: 'S.No.', selector: row => podcastData?.length - podcastData.indexOf(row), style: { backGroundColor: "#000", paddingLeft: "20px" } },
    { name: 'Category', selector: row => row?.audioCategoryId?.category_name },
    { name: 'Sub Category', selector: row => row?.audioSubCategoryId?.sub_category_name },
    { name: 'Podcast', selector: row => row?.title },
    { name: 'Image', cell: row => <img src={row?.image ? api_urls + row?.image : logo_icon} alt="Profile" style={{ width: '50px', height: '50px', borderRadius: '50%' }} /> },
    // { name: 'Link', selector: row => <Link target="_blank" to={row?.link} >Link</Link> },
    { name: 'Trending', selector: row => row?.is_trending ? 'Trending' : 'Not Trending' },
    { name: 'Status', selector: row => <div onClick={() => dispatch(SancharActions.changePodcastStatus({ audioId: row?._id }))} style={{ cursor: "pointer" }}>{row?.status == 'Active' ? <SwitchOnSvg /> : <SwitchOffSvg />}</div> },
    {
      name: 'Action',
      cell: row => <div style={{ display: "flex", gap: "20px", alignItems: "center" }} >
        {/* <div onClick={() => handleEdit(row)} style={{ cursor: "pointer" }}><EditSvg /></div> */}
        <div onClick={() => dispatch(SancharActions.deletePodcast({ audioId: row?._id }))} style={{ cursor: "pointer" }}><DeleteSvg /></div>
      </div>,
      width: "180px"
    },
  ];

  useEffect(() => {
    //! Dispatching API for Getting Podcast
    dispatch(SancharActions.getPodcast())

    //! Dispatching API for Getting Category
    dispatch(CategoryActions.getCategory())
  }, []);

  useEffect(() => {
    //! Dispatching API for Getting Sub Category
    podcastDetail?.categoryId && dispatch(SubCategoryActions.getSubCategoryByCategoryId({ categoryId: podcastDetail?.categoryId }))
  }, [podcastDetail?.categoryId]);

  return (
    <>
      <MainDatatable data={podcastData} columns={podcastColumns} title={'Podcast'} url={'/add-podcast'} />


      <Dialog
        open={modalVisible}>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item lg={12} sm={12} md={12} xs={12} sx={{ marginBottom: "20px" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div style={{ fontSize: "23px", fontWeight: "600" }}>Edit Podcast</div>
                <div onClick={() => setModalVisible(false)}><CloseRounded /></div>
              </div>
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12} >
              <FormControl fullWidth>
                <InputLabel id="select-label">Select Category Name</InputLabel>
                <Select
                  label="Select Category Name" variant="outlined" fullWidth
                  name='categoryId'
                  value={podcastDetail?.categoryId}
                  onChange={handleInputField}
                  error={inputFieldError?.categoryId ? true : false}
                  onFocus={() => handleInputFieldError("categoryId", null)}
                >
                  <MenuItem disabled>---Select Category---</MenuItem>
                  {redirectCategoryData.map((value, index) => <MenuItem key={index} value={value?._id}>{value?.category_name}</MenuItem>)}
                </Select>
              </FormControl>
              {inputFieldError?.categoryId && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.categoryId}</div>}
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12} >
              <FormControl fullWidth>
                <InputLabel id="select-label">Select Sub Category</InputLabel>
                <Select
                  label="Select Sub Category" variant="outlined" fullWidth
                  name='subCategoryId'
                  value={podcastDetail?.subCategoryId}
                  onChange={handleInputField}
                  error={inputFieldError?.subCategoryId ? true : false}
                  onFocus={() => handleInputFieldError("subCategoryId", null)}
                >
                  {subCatgeoryDataByCategoryId.length == 0 ? <MenuItem disabled>---Please First Select category---</MenuItem> : <MenuItem disabled>---Select Sub Category---</MenuItem>}
                  {subCatgeoryDataByCategoryId && subCatgeoryDataByCategoryId.length == 0 ? <MenuItem disabled>You don't have Sub category</MenuItem> : subCatgeoryDataByCategoryId?.map(value => (<MenuItem key={value?._id} value={value?._id}>{value?.sub_category_name}</MenuItem>))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12} >
              <TextField
                label="Podcast Name" variant='outlined' fullWidth
                name='podcastName'
                value={podcastDetail?.podcastName}
                onChange={handleInputField}
                error={inputFieldError.podcastName ? true : false}
                helperText={inputFieldError.podcastName}
                onFocus={() => handleInputFieldError("podcastName", null)}
              />
            </Grid>

            {/* <Grid item lg={6} sm={6} md={12} xs={12} >
              <Grid container sx={{ alignItems: "center", flexWrap: "nowrap" }}>
                <Grid item xs={2} >
                  <Avatar src={image.file} style={{ width: 40, height: 40 }} />
                </Grid>
                <Grid component="label" item xs={10} style={{ backgroundColor: "#E2E8F0", textAlign: "center", color: "#666666", padding: "10px 30px", borderRadius: "20px", cursor: "pointer", fontWeight: "500", fontSize: "14px" }}>
                  Upload Podcast Image
                  <input onChange={handleImage} hidden accept="image/*" type="file" />
                </Grid>
              </Grid>
              {inputFieldError?.image && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "10px 0 0 15px" }}>{inputFieldError?.image}</div>}
            </Grid> */}

            <Grid item lg={6} md={6} xs={12}>
              <Grid container sx={{ alignItems: "center", flexWrap: "nowrap" }}>
                <Grid component="label" item xs={12} style={{ padding: "10px", textAlign: "center", color: "#666666", border: "1px solid #C4C4C4", borderRadius: "20px", cursor: "pointer", fontWeight: "500", fontSize: "14px" }}>
                  {audio?.bytes ? audio?.bytes?.name : 'Upload Podcast Audio'}
                  <input onChange={handleAudio} hidden accept="audio/*" type="file" />
                </Grid>
              </Grid>
              {inputFieldError.audio && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "10px 0 0 15px" }}>{inputFieldError.audio}</div>}
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12} >
              <TextField
                label="Podcast Link" variant='outlined' fullWidth
                name='link'
                value={podcastDetail?.link}
                onChange={handleInputField}
                error={inputFieldError.link ? true : false}
                helperText={inputFieldError.link}
                onFocus={() => handleInputFieldError("link", null)}
              />
            </Grid>

            <Grid item lg={6} md={12} sm={12} xs={12} >
              <TextField
                label="Artist" variant='outlined' fullWidth
                name='artist'
                value={podcastDetail?.artist}
                onChange={handleInputField}
                error={inputFieldError.artist ? true : false}
                helperText={inputFieldError.artist}
                onFocus={() => handleInputFieldError("artist", null)}
              />
            </Grid>

            <Grid item lg={6} md={12} sm={12} xs={12} >
              <TextField
                label="Duration" variant='outlined' fullWidth
                name='duration'
                value={podcastDetail?.duration}
                onChange={handleInputField}
                error={inputFieldError.duration ? true : false}
                helperText={inputFieldError.duration}
                onFocus={() => handleInputFieldError("duration", null)}
              />
            </Grid>

            <Grid item lg={6} md={6} xs={12} >
              <div style={{ display: "flex", gap: "20px", border: "1px solid #C4C4C4", padding: "16px 13.5px", borderRadius: "5px" }}>
                <label style={{ cursor: "pointer", color: "#666666", fontFamily: "Philosopher", fontSize: "13.5px", color: "#667284" }} htmlFor="layout-template">Trending Podcast</label>
                <input defaultChecked={trending} onClick={(e) => setTrending(e.target.checked)} style={{ cursor: "pointer", marginTop: "0px", padding: "0px" }} id='layout-template' type="checkbox" />
              </div>
            </Grid>

            <Grid item lg={12} md={12} sm={12} xs={12} >
              <TextField
                label="Description" variant='outlined' fullWidth
                name='description'
                value={podcastDetail?.description}
                onChange={handleInputField}
                error={inputFieldError.description ? true : false}
                helperText={inputFieldError.description}
                onFocus={() => handleInputFieldError("description", null)}
              />
            </Grid>

            <Grid item lg={12} sm={12} md={12} xs={12} sx={{ marginTop: "15px" }}>
              <Grid container spacing={2}>
                <Grid item lg={6} sm={6} md={6} xs={6} >
                  <div onClick={handleSubmit} style={{ fontWeight: "500", backgroundColor: "#164E62", color: "#fff", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px", textAlign: "center", fontFamily: "Philosopher" }}>Submit</div>
                </Grid>
                <Grid item lg={6} sm={6} md={6} xs={6} >
                  <div onClick={() => setModalVisible(false)} style={{ fontWeight: "500", backgroundColor: "#EDF2F5", color: "#000", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px", textAlign: "center", fontFamily: "Philosopher" }}>
                    Close
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DisplayPodcast;